import { CKEditor } from '@ckeditor/ckeditor5-react'
import { Box } from '@mui/material'
import Editor from 'ckeditor5-custom-build'
import Cookies from 'js-cookie'
import { useEffect, useMemo } from 'react'

interface RichTextEditorProps {
  editor?: Editor
  setEditor: (editor: Editor) => void
  value: string
  placeholder?: string
  removePlugins?: string[]
  imageUploadUrl?: string
}

export default function RichTextEditor({
  editor,
  setEditor,
  placeholder,
  value,
  imageUploadUrl,
  removePlugins = []
}: Readonly<RichTextEditorProps>) {
  useEffect(() => {
    editor?.setData(value)
  }, [value, editor])

  const csrftoken = Cookies.get('csrftoken')
  const simpleUploadConf = imageUploadUrl && {
    uploadUrl: imageUploadUrl,
    ...(csrftoken && { headers: { 'X-CSRFToken': csrftoken } }),
    withCredentials: true
  }
  return useMemo(
    () => (
      <Box sx={{ minHeight: 300 }}>
        <CKEditor
          editor={Editor}
          data={value}
          config={{
            placeholder: placeholder,
            removePlugins: removePlugins,
            ...(simpleUploadConf && { simpleUpload: simpleUploadConf }),
            toolbar: [
              'heading',
              '|',
              'bold',
              'italic',
              'link',
              'bulletedList',
              'numberedList',
              'blockQuote',
              '|',
              'undo',
              'redo',
              '|',
              'insertImage'
            ],
            image: {
              resizeUnit: 'px'
            },
            link: {
              defaultProtocol: 'https://',
              decorators: {
                isExternal: {
                  mode: 'automatic',
                  callback: url => (url ? /^https?:\/\//i.test(url) : false),
                  attributes: {
                    target: '_blank',
                    rel: 'noopener noreferrer'
                  }
                }
              }
            }
          }}
          onReady={editor => {
            editor.editing.view.change(writer => {
              const root = editor.editing.view.document.getRoot()
              if (root) {
                writer.setStyle('height', '300px', root)
              }
            })
            setEditor(editor)
          }}
        />
      </Box>
    ),
    [value]
  )
}
